import React, { Component } from "react";

import Checkbox from "../../elements/Checkbox";
import { matchFieldTypes } from "../../data/entity_fields";
import Select from "../../elements/Select";
import Money from "../../elements/Money";
import BxApi from "../../services/bx-api";
import CompaniesOfContact from "../CompaniesOfContact";
import CustomField from "../CustomField";
import FloatInput from "../../elements/FloatInput";
import TextField from "../../elements/TextField";
import FormField from "../../elements/FormField";
import IntegerInput from "../../elements/IntegerInput";
import PriceInput from "../../elements/PriceInput";
import Link from "../../elements/Link";
import ArrayOf from "../../elements/ArrayOf";
import DateTime from "../../elements/datetime";
import DealsBinding from "../DealsBinding";
import { entityLabelFunc } from "../../utils"
import CRMField from "../../elements/crm";
import { smartProcessTitlesMatchData } from "../../data/crm_list_data";

const STORAGE_NAME = "active_fields";

const crmStatusId = {
    'SOURCE_ID': 'SOURCE',
    'STATUS_ID': 'STATUS'
};

const pageSize = 50;

const userFieldTypes = [ 'employee', 'user' ];

const arrToObj = (arr, fieldName, fieldValue) => arr.reduce((a, v) => ({ ...a, [fieldName(v)]: fieldValue(v)}), {});
const formattedFunc = {
    'common.user': ({ ID, NAME, SECOND_NAME, LAST_NAME }) => ({
        value: ID,
        label: [LAST_NAME, NAME, SECOND_NAME].filter(val => typeof val === 'string' && val.length > 0).join(` `)
    }),
    'common.lead': ({ ID, TITLE }) => ({
        value: ID,
        label: TITLE
    }),
    'common.contact': ({ ID, NAME, SECOND_NAME, LAST_NAME }) => ({
        value: ID,
        label: [LAST_NAME, NAME, SECOND_NAME].filter(val => typeof val === 'string' && val.length > 0).join(` `)
    }),
    'common.company': ({ ID, TITLE }) => ({
        value: ID,
        label: TITLE
    }),
    'common.order': ({ ID, TITLE }) => ({
        value: ID,
        label: TITLE
    }),
    'common.deal': ({ ID, TITLE }) => ({
        value: ID,
        label: TITLE
    }),
    'common.quote': ({ ID, TITLE }) => ({
        value: ID,
        label: TITLE
    }),
    'common.invoice': ({ ID, ORDER_TOPIC }) => ({
        value: ID,
        label: ORDER_TOPIC
    }),
    'iBlockList': ({ ID, NAME }) => ({
        value: ID,
        label: NAME
    }),
    'smartProcess': ({ id, title }) => ({
        value: id,
        label: title
    })
};
const matchIBlockListTypes = {
    list: 'lists',
    bxProcess: 'bitrix_processes'
};
const requestDataMatch = {
    'common.user': () => ({
        FILTER: {
            USER_TYPE: 'employee',
            ACTIVE: true
        }
    }),
    'iBlockList': data => ({
        IBLOCK_TYPE_ID: matchIBlockListTypes[data.listType],
        IBLOCK_ID: data.listId
    }),
    'smartProcess': data => ({
        entityTypeId: +data.listId
    })
};
const requestURLData = {
    'common.user': 'user.get',
    'common.lead': 'crm.lead.list',
    'common.contact': 'crm.contact.list',
    'common.company': 'crm.company.list',
    // TODO: непонятно, откуда брать эти заказы и надо ли ее вообще получать
    'common.order': 'sales.order.list',
    'common.deal': 'crm.deal.list',
    'common.quote': 'crm.quote.list',
    'common.invoice': 'crm.invoice.list',
    'common.requisite': 'crm.requisite.list',
    // TODO: надо ли добавлять этих ребят, непонятно
    // DO: 'smart documents',
    // SBD: 'smart b2e doc'
    'iBlockList': 'lists.element.get',
    'smartProcess': 'crm.item.list'
};
const filterDataMatch = {
    'common.user': filter => ({
        ...(filter ? { '=%LAST_NAME': `%${filter}%` } : {})
    }),
    'common.lead': filter => ({
        ...(filter ? {TITLE: `%${filter}%`} : {})
    }),
    'common.contact': [
        filter => ({
            ...(filter ? { '=%LAST_NAME': `%${filter}%` } : {})
        }),
        filter => ({
            ...(filter ? { '=%NAME': `%${filter}%` } : {})
        })
    ],
    'common.company': filter => ({
        ...(filter ? {TITLE: `%${filter}%`} : {})
    }),
    'common.order': filter => ({
    // TODO: непонятно, какое строение к этой сущности и надо ли ее вообще получать
        ...(filter ? {TITLE: `%${filter}%`} : {})
    }),
    'common.deal': filter => ({
        ...(filter ? {TITLE: `%${filter}%`} : {})
    }),
    'common.quote': filter => ({
        ...(filter ? {TITLE: `%${filter}%`} : {})
    }),
    'common.invoice': filter => ({
        ...(filter ? {ORDER_TOPIC: `%${filter}%`} : {})
    }),
    'common.requisite': filter => ({
        ...(filter ? {NAME: `%${filter}%`} : {})
    }),
    'iBlockList': filter => ({
        ...(filter ? {NAME: `%${filter}%`} : {})
    }),
    'smartProcess': filter => ({
        ...(filter ? {title: `%${filter}%`} : {})
    })
};

const listsFormatted = ({commonType, listType}, oldList, newPage) => {
    console.log('list formatted', commonType, listType, oldList, newPage);
    const newPageSorted = newPage
        .map(formattedFunc[commonType + (commonType === 'common' ? `.${listType}` : '')])
        .toSorted(({ label: a }, { label: b }) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        });
    return (oldList.length > 0 ? [...oldList.filter(u => !newPageSorted.find(nu => nu.value === u.value)), ...newPageSorted] : newPageSorted);
};

const usersFormatted = (oldList, newList) => {
    const newUsers = newList
        .map(({ ID, NAME, SECOND_NAME, LAST_NAME }) => ({
            value: ID,
            label: [LAST_NAME, NAME, SECOND_NAME].filter(val => typeof val === 'string' && val.length > 0).join(` `)
        }))
        .toSorted(({ label: a }, { label: b }) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        });
    return (oldList.length > 0 ? [...oldList.filter(u => !newUsers.find(nu => nu.value === u.value)), ...newUsers] : newUsers);
};

class EntityEdit extends Component {
    static inputID = null;

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            options: [],
            listData: [],
            fields: null,
            statuses: null,
            fieldsLoaded: false,
            allDataIsReceived: {}
        };
    }

    async componentDidMount() {
        const { type, entity, t, i18n } = this.props;
        this.bxApi = new BxApi();

        const storage = await this.bxApi.rest("entity.item.get", { ENTITY: STORAGE_NAME });

        if (storage.length === 0) {
            this.setState({fields: [], fieldsLoaded: true});
            return;
        }

        let selectedFields = storage.find(
            ({ NAME }) => NAME === `${STORAGE_NAME}-${type}`
        );

        if (typeof selectedFields === "object") {
            selectedFields = JSON.parse(selectedFields.DETAIL_TEXT);
        }

        if (!Array.isArray(selectedFields)) {
            console.debug('fields', selectedFields);
            this.setState({fieldsLoaded: true});
            return;
        }

        console.debug('fields', selectedFields);

        const fieldWithoutTranslate = selectedFields.filter(field => !(i18n.exists('common.' + field.field) || i18n.exists(type + '.' + field.field) || field.label));
        let titles = [];

        if (fieldWithoutTranslate.length > 0) {
            titles = await this.bxApi.rest(`crm.${type}.fields`);
            const storageItem = storage.find(({NAME}) => NAME === `${STORAGE_NAME}-${type}`);
            const formattedSelectedFields = selectedFields.map(field => {
                return {
                    ...field,
                    ...(fieldWithoutTranslate.find(tmpField => tmpField.field === field.field) && titles[field.field] ? {
                        label: titles[field.field].formLabel || titles[field.field].title
                    } : {})
                };
            });
            const data = (typeof formattedSelectedFields === 'string') ? formattedSelectedFields : JSON.stringify(formattedSelectedFields);
            console.debug('change entity', fieldWithoutTranslate, formattedSelectedFields);
            if (storageItem) {
                await this.bxApi.rest('entity.item.update', {
                    ENTITY: STORAGE_NAME,
                    ID: storageItem.ID,
                    DETAIL_TEXT: data
                });
            } else {
                await this.bxApi.rest('entity.item.add', {
                    ENTITY: STORAGE_NAME,
                    NAME: `${STORAGE_NAME}-${type}`,
                    DETAIL_TEXT: data
                });
            }
        }

        selectedFields = selectedFields.map(field => {
            return {
                ...field,
                label: i18n.exists(type + '.' + field.field)
                    ? t(type + '.' + field.field)
                    : i18n.exists('common.' + field.field)
                        ? t('common.' + field.field)
                        : field.label || (
                            titles[field.field]
                            ? (titles[field.field].formLabel || titles[field.field].title)
                            : field.field
                        )
            };
        });

        console.debug('selectedFields step 3', selectedFields);
        const requiredUsers = selectedFields.filter(({ type }) => userFieldTypes.includes(type)).map(f => entity[f.field]).filter(val => val.length > 0);

        let needSmartProcessShortCodes = false;
        const listData = selectedFields.reduce((acc, {field, type, data}) => {
            switch (type) {
                case 'employee':
                case 'user':
                    const oldUserList = acc.find(cList => cList.listType === 'user');
                    if (oldUserList) {
                        oldUserList.fieldIdArray.push(field);
                        return acc;
                    } else {
                        return [ ...acc, { commonType: 'common', listType: 'user', fieldIdArray: [ field ], elements: [] } ];
                    }
                case 'iblock_element':
                    const oldIBlockList = acc.find(cList => cList.commonType === 'iBlockList' && cList.listType === data.listType && cList.listId === data.listId);
                    if (oldIBlockList) {
                        oldIBlockList.fieldIdArray.push(field);
                        return acc;
                    } else {
                        return [ ...acc, { commonType: 'iBlockList', listType: data.listType, listId: data.listId, fieldIdArray: [ field ], elements: [] } ];
                    }
                case 'crm':
                    needSmartProcessShortCodes = true;
                    const newSmartProcesses = data.fields.map(cField => {
                        if (cField.startsWith('DYNAMIC')) {
                            const listId = cField.split('_')[1];
                            const oldDynamicList = acc.find(cList => cList.commonType === 'smartProcess' && cList.listId === listId);
                            if (oldDynamicList) {
                                oldDynamicList.fieldIdArray.push(field);
                                return null;
                            }
                            return {
                                commonType: 'smartProcess',
                                listType: undefined,
                                listId,
                                fieldIdArray: [ field ],
                                elements: []
                            };
                        }
                        const listType = smartProcessTitlesMatchData[cField];
                        const oldList = acc.find(cList => cList.commonType === 'common' && cList.listType === listType);
                        if (oldList) {
                            oldList.fieldIdArray.push(field);
                            return null;
                        }
                        return {
                            commonType: 'common',
                            listType,
                            listId: undefined,
                            fieldIdArray: [ field ],
                            elements: []
                        };
                    });
                    return [
                        ...acc,
                        ...newSmartProcesses.filter(newProcess => !!newProcess)
                    ];
                    default:
                        return acc;
            }
        }, []);

        const statusesDataRequests = {
            ...arrToObj(
                selectedFields
                    .filter(({ type }) => ["select", "crm_status"].includes(type))
                    .map(({field}) => ({
                        field,
                        // TODO: вписать в логику listData
                        requestParams: ["crm.status.list", {
                            filter: { ENTITY_ID: field === 'TYPE_ID' ? 'CONTACT_TYPE' : crmStatusId[field] || field },
                        }]
                    })),
                v => v.field,
                v => v.requestParams
            ),
            ...(selectedFields.find(({ field }) => field === 'COMPANY_ID') ? {
                COMPANY_NAME: ['crm.company.get', {id: entity.COMPANY_ID}]
            } : {}),
            ...(selectedFields.find(({ type }) => type === 'datetime') ? {
                serverTime: ['server.time', {}]
            } : {}),
            ...(requiredUsers.reduce((acc, val) => {
                return { ...acc, [`user${val}`]: ['user.get', { FILTER: { ID: val } }] }
            }, {})),
            ...listData.reduce((acc, val) => {
                const listLongCode = val.commonType + (val.commonType === 'common' ? `.${val.listType}` : '');
                const dataFunc = requestDataMatch[listLongCode];
                return {
                    ...acc,
                    [`list:${val.commonType}.${val.listType}.${val.listId}`]: [
                        requestURLData[listLongCode],
                        dataFunc ? dataFunc({listType: val.listType, listId: val.listId}) : {}
                    ]
                }
            }, {}),
            ...(needSmartProcessShortCodes ? { smartProcessShortCodes: [ "crm.enum.ownertype", {} ] } : {})
        };

        if (selectedFields.find(({type}) => type === 'crm_currency' || type === 'money')) {
            statusesDataRequests.CURRENCY_ID = ["crm.currency.list", {}];
        }

        selectedFields
            .filter(({ type }) => type.startsWith('enumeration'))
            .forEach(({ field, id }) => {
                statusesDataRequests[field] = [`crm.${type}.userfield.get`, {id}];
            });

        if (Object.keys(statusesDataRequests).length === 0) {
            this.setState({ fields: selectedFields, fieldsLoaded: true });
            return;
        }

        this.bxApi.batch(statusesDataRequests, {
            ...listData
                .reduce((acc, val) => ({...acc, [`list:${val.commonType}.${val.listType}.${val.listId}`]: data => data.answer}), {})
        })
            .then(({CURRENCY_ID, COMPANY_NAME, smartProcessShortCodes, serverTime, ...other}) => {
                const data = {};
                if (CURRENCY_ID) {
                    data.CURRENCY_ID = CURRENCY_ID.map(
                        ({ CURRENCY, FULL_NAME }) => ({
                            value: CURRENCY,
                            label: FULL_NAME,
                        })
                    );
                }
                if (COMPANY_NAME) {
                    data.COMPANY_NAME = COMPANY_NAME.TITLE;
                }
                const otherKeys = Object.keys(other);
                const otherListKeys = otherKeys.filter(key => key.startsWith('list'));
                const otherNotUserKeys = otherKeys.filter(key => !key.startsWith('user') && !key.startsWith('list'));
                let allDataIsReceived = {};
                if (otherListKeys.length > 0) {
                    listData.forEach(listItem => {
                        const listKey = `list:${listItem.commonType}.${listItem.listType}.${listItem.listId}`;
                        const currentListData = other[listKey];
                        const currentListDataResult = listItem.commonType === 'smartProcess' ? currentListData.result.items : currentListData.result;
                        listItem.allDataIsReceived = currentListData.total === currentListDataResult.length;
                        listItem.page = 1;
                        listItem.elements = listsFormatted({ commonType: listItem.commonType, listType: listItem.listType }, [], currentListDataResult);
                    });
                }
                const dataAdditional = otherNotUserKeys.reduce((acc, val) => {
                    if (typeof other[val] !== 'object' || Object.keys(other[val]).length === 0) {
                        return acc;
                    }
                    const multiple = other[val].MULTIPLE === 'Y';
                    return {
                        ...acc,
                        [val]: other[val].LIST
                            ? other[val].LIST.map(({ID, VALUE}) => ({value: multiple ? +ID : ID, label: VALUE}))
                            : other[val].map(({ID, NAME, STATUS_ID}) => ({value: multiple ? +ID : STATUS_ID, label: NAME}))
                    };
                }, {});
                const options = { ...data, ...dataAdditional };
                console.log('options', options, listData);
                const serverTimeZoneOffsetInHoursString = serverTime ? serverTime.substring(19, 22) : null;
                this.setState({
                    options,
                    listData,
                    fields: selectedFields,
                    fieldsLoaded: true,
                    allDataIsReceived: { ...this.state.allDataIsReceived, ...allDataIsReceived },
                    ...(serverTime ? { serverTimeZone: `Etc/GMT${serverTimeZoneOffsetInHoursString}` } : {}),
                    ...(smartProcessShortCodes ? { smartProcessShortCodes } : {})
                });
            });
    }

    fetchData = async (lists, filter) => { // lists is array of { commonType, listType, listId }
        const { options, allDataIsReceived, listData } = this.state;
        lists = lists.filter(cList => !cList.allDataIsReceived);
        if (lists.length === 0) {
            return;
        }

        const fetchReqData = lists.reduce((acc, val) => {
            const listLongCode = val.commonType + (val.commonType === 'common' ? `.${val.listType}` : '');
            const baseDataFunc = requestDataMatch[listLongCode];
            const filterDataFunc = filterDataMatch[listLongCode];
            const initialReqData = {
                ...(baseDataFunc ? baseDataFunc({listType: val.listType, listId: val.listId}) : {}),
                start: filter ? 0 : pageSize * (val.page || 0)
            };
            const reqData = [];
            if (!filter || !filterDataFunc) {
                reqData.push(initialReqData);
            } else if (typeof filterDataFunc === 'function') {
                const tmpReqData = { ...initialReqData };
                tmpReqData.FILTER = { ...(tmpReqData.FILTER || {}), ...filterDataFunc(filter) };
                reqData.push(tmpReqData);
            } else {
                reqData.push(...filterDataFunc.map(filterFunc => {
                    const tmpReqData = { ...initialReqData };
                    tmpReqData.FILTER = { ...(tmpReqData.FILTER || {}), ...filterFunc(filter) };
                    return tmpReqData;
                }));
            }
            return {
                ...acc,
                ...reqData.reduce((acc, reqDataElem, i) => {
                    return {...acc, [`list:${val.commonType}.${val.listType}.${val.listId}.${i}`]: [ requestURLData[listLongCode], reqDataElem ]}
                }, {})
            }
        }, {});
        
        console.log('fetchData: request', lists, filter, fetchReqData);
        const dataResponse = await this.bxApi.batch(
            fetchReqData,
            Object.keys(fetchReqData).reduce((acc, val) => ({...acc, [val]: data => data.answer}), {})
        );
        console.log('fetchData: response', dataResponse);
        const responseKeys = Object.keys(dataResponse);
        const undefinedOrString = val => val === 'undefined' ? undefined : val;
        const marshalledData = responseKeys.forEach(val => {
            const data = dataResponse[val];
            const [tmpCommonType, tmpListType, tmpListId] = val.split(':')[1].split('.');
            const commonType = undefinedOrString(tmpCommonType);
            const listType = undefinedOrString(tmpListType);
            const listId = undefinedOrString(tmpListId);
            const result = commonType === 'smartProcess' ? data.result.items : data.result;
            const listElem = listData.find(cList => cList.commonType === commonType && cList.listType === listType && cList.listId === listId);
            if (!listElem) {
                // TODO: что делать???
            }
            listElem.elements = listsFormatted({ commonType: listElem.commonType, listType: listElem.listType }, listElem.elements, result);
            
            if (!filter) { // если был фильтр, то возможно данные получены с разных страниц
                listElem.page += 1;
            }
            listElem.allDataIsReceived = listElem.elements.length === data.total;
            if (listElem.elements.length > data.total) {
                // TODO: это случается на тестах, исправить
                // alert('это странно, дублирование в listElem.elements');
            }

        });
        this.setState({listData});
    }

    renderSapsanFields = () => {
        const { changeEntity, entity, type } = this.props;
        const fields = [];

        if (type !== "contact") {
            return '';
        }

        return ([...fields, {
            field: "UF_CRM_1645451252",
            label: "Статус клиента",
            type: "contactCustomField",
            disabled: true,
        }]).map(
            ({ field, label, type, disabled = false, multiple = false }, i) => {
                const props = {
                    field,
                    label,
                    type,
                    disabled,
                    multiple,
                    value: entity[field],
                    change: changeEntity,
                };
                return (
                    <CustomField
                        {...props}
                        id={entity.ID}
                        entityType="contact"
                        key={i}
                    />
                );
            }
        );
    };

    renderFields = () => {
        const { changeEntity, entity, t, userTimeZone } = this.props;
        const { fields, fieldsLoaded, options, listData, smartProcessShortCodes, serverTimeZone } = this.state;

        if (!fieldsLoaded) {
            return t('loading');
        }

        if (!Array.isArray(fields)) {
            return (
                <div>{t('fieldsLoadingError')}</div>
            )
        }
        if (fields.length === 0) {
            return (
                <div>{t('noCheckedFields')}</div>
            )
        }

        console.debug('all', entity, fields, options, listData, this.state.allDataIsReceived);

        return fields.map(
            ({ field, label, type, disabled = false, multiple = false, data, required }, i) => {
                const props = {
                    field,
                    type,
                    disabled,
                    multiple,
                    value: entity[field],
                    change: changeEntity,
                    data,
                    required
                };

                let message = null;

                console.log('props', props);

                const clearField = (emptyValue = '') => {
                    if (required || required === undefined) {
                        return null;
                    }
                    return () => changeEntity(emptyValue, field);
                };

                switch (matchFieldTypes[field] || type) {
                    case "address":
                        props.value = multiple ? props.value.map(elem => elem.split('|')[0]) : props.value.split('|')[0];
                        data.rows = 2;
                        message = t('addressFieldDisclaimer');
                    // eslint-disable-next-line no-fallthrough
                    case "string":
                    case "textarea":
                        if (multiple) {
                            return (
                                <FormField label={label} key={i} up>
                                    <>
                                        <ArrayOf label={label} {...props} ItemComponent={TextField} />
                                        {message && (
                                            <div className="disclaimer" style={{marginTop: 6}}>{message}</div>
                                        )}
                                    </>
                                </FormField>
                            );
                        }

                        return (
                            <FormField label={label} key={i} clearField={clearField()}>
                                <>
                                    <TextField {...props} resize />
                                    {message && (
                                        <div className="disclaimer" style={{marginTop: 6}}>{message}</div>
                                    )}
                                </>
                            </FormField>
                        );
                    case "integer":
                        if (field.endsWith('_ID')) {
                            return null;
                        }
                        return (
                            <FormField label={label} key={i} clearField={clearField()}>
                                <IntegerInput {...props} />
                            </FormField>
                        );
                    case "double":
                        if (multiple) {
                            return (
                                <FormField label={label} key={i} up>
                                    <ArrayOf label={label} {...props} ItemComponent={FloatInput} valueType="float" />
                                </FormField>
                            );
                        }
                        return (
                            <FormField label={label} key={i} clearField={clearField()}>
                                <FloatInput {...props} />
                            </FormField>
                        );
                    case "select":
                    case "crm_currency":
                    case "crm_status":
                    case "enumeration":
                        return (
                            <FormField label={label} key={i} clearField={!props.multiple && clearField()} isSelect>
                                <Select {...props} options={options[field]} />
                            </FormField>
                        );
                    case 'crm':
                        const fetchCRMListHandler = (filter) => this.fetchData(
                            props.data.fields
                                .map(crmFieldKey => {
                                    const currentList = listData.find(cList =>
                                        crmFieldKey.startsWith('DYNAMIC') ?
                                            crmFieldKey === `DYNAMIC_${cList.listId}` :
                                            smartProcessTitlesMatchData[crmFieldKey] === cList.listType
                                    );
                                    return currentList;
                                }),
                            filter
                        ).then();
                        return (
                            <FormField label={label} key={i} clearField={!props.multiple && clearField()} isSelect>
                                <CRMField
                                    {...props}
                                    options={listData}
                                    smartProcessShortCodes={smartProcessShortCodes}
                                    fetchList={fetchCRMListHandler}
                                />
                            </FormField>
                        );
                    case "iblock_element":
                        const currentListData = listData.find(listElem => {
                            return listElem.fieldIdArray.indexOf(props.field) !== -1;
                        });
                        const elements = currentListData.elements;
                        const fetchIBlockListHandler = (filter) => this.fetchData([currentListData], filter).then();
                        if (multiple) {
                            return (
                                <FormField label={label} key={i} up isSelect>
                                    <ArrayOf
                                        label={label}
                                        {...props}
                                        itemProps={{
                                            options: elements,
                                            fetchList: fetchIBlockListHandler
                                        }}
                                        ItemComponent={Select}
                                        // valueType="float"
                                    />
                                </FormField>
                            );
                        }
                        return (
                            <FormField label={label} key={i} clearField={clearField()} isSelect>
                                <Select {...props} options={elements} fetchList={fetchIBlockListHandler}/>
                            </FormField>
                        );
                    case "employee":
                    case "user":
                        const usersList = listData.find(({commonType, listType}) => commonType === 'common' && listType === 'user');
                        const fetchUsers = (filter) => this.fetchData([usersList], filter).then();
                        if (multiple) {
                            return (
                                <FormField label={label} key={i} up isSelect>
                                    <ArrayOf
                                        label={label}
                                        {...props}
                                        itemProps={{
                                            options: usersList.elements,
                                            fetchList: fetchUsers
                                        }}
                                        ItemComponent={Select}
                                        valueType="float"
                                    />
                                </FormField>
                            );
                        }
                        return (
                            <FormField label={label} key={i} clearField={clearField()} isSelect>
                                <Select {...props} options={usersList.elements} fetchList={fetchUsers} />
                            </FormField>
                        );
                    case "char":
                        if (!['Y', 'N', undefined].includes(props.value)) {
                            alert('обнаружено необрабатываемое поле. обратитесь в техподдержку. ' + type + ' - ' + props.field + ' - ' + props.value);
                            return '';
                        }
                        return (
                            <FormField label={label} key={i} clearField={clearField('N')}>
                                <Checkbox {...props} formatter={['Y', 'N']} />
                            </FormField>
                        );
                    case 'boolean':
                        return (
                            <FormField label={label} key={i}>
                                <Checkbox {...props} formatter={['1', '0']} />
                            </FormField>
                        );
                    case 'price':
                        return (
                            <FormField label={label} key={i} clearField={clearField()}>
                                <PriceInput {...props} />
                            </FormField>
                        );
                    case 'money':
                        if (multiple) {
                            return (
                                <FormField label={label} key={i} up isSelect>
                                    <ArrayOf
                                        label={label}
                                        {...props}
                                        itemProps={{currencyList: options.CURRENCY_ID}}
                                        ItemComponent={Money}
                                        valueType="money"
                                    />
                                </FormField>
                            );
                        }
                        return (
                            <FormField label={label} key={i} isSelect>
                                <Money {...props} currencyList={options.CURRENCY_ID} />
                            </FormField>
                        );
                    case 'crm_company':
                        return (
                            <FormField label={label} key={i}>
                                <Link {...props} title={options.COMPANY_NAME} />
                            </FormField>
                        );
                    case "CompaniesOfContact":
                        return (
                            <CompaniesOfContact
                                label={label}
                                {...props}
                                id={entity.ID}
                                key={i}
                            />
                        );
                    case "array":
                    case "crm_multifield":
                        return (
                            <FormField label={label} key={i} up>
                                <ArrayOf
                                    label={label}
                                    {...props}
                                    ItemComponent={TextField}
                                    valueType="objectElem"
                                />
                            </FormField>
                        );
                    case "datetime":
                        console.log('datetime field', props);
                        if (props.multiple) {
                            return (
                                <FormField label={label} key={i}>
                                    <ArrayOf
                                        label={label}
                                        {...props}
                                        ItemComponent={DateTime}
                                        itemProps={{ serverTimeZone, userTimeZone }}
                                    />
                                </FormField>
                            );
                        } else {
                            return (
                                <FormField label={label} key={i}>
                                    <DateTime {...props} serverTimeZone={serverTimeZone} userTimeZone={userTimeZone} />
                                </FormField>
                            );
                        }
                    default:
                        return null;
                }
            }
        );
    };

    render() {
        const { entity, t, saveStatus, deals, onBindDealChange, onDealsListOpen, type } = this.props;
        const currentLocation =
            ((Array.isArray(window.location.ancestorOrigins) && window.location.ancestorOrigins.length > 0)
            ? window.location.ancestorOrigins[0]
            : (typeof document.referrer === `string` && document.referrer.length > 0)
                ? document.referrer
                : `<undefined>`).replace(/\/+$/, "");

        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <form className="form">
                    <div style={{ display: `flex`, justifyContent: 'center', padding: `0 42px 16px`, fontSize: 18, fontWeight: 500 }}>
                        <span>{t(`${type}.entityLabel`)}</span>
                        <a
                            href={`${currentLocation}/crm/${type}/details/${entity.ID}/`}
                            target="_blank" rel="noopener noreferrer" style={{ marginLeft: 6 }}
                        >
                            {entityLabelFunc[type](entity)}
                        </a>
                    </div>
                    {this.renderFields()}
                    {this.renderSapsanFields()}
                    {Array.isArray(deals) && (
                        <DealsBinding deals={deals} onBindDealChange={onBindDealChange} onDealsListOpen={onDealsListOpen} />
                    )}
                </form>
            </div>
        );
    }
}

export default EntityEdit;
